import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { ActivesService } from './services/actives.service';
import { UserService } from './core/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class InitialDataResolver  {
  /**
   * Constructor
   */
  constructor(
    private _activeService: ActivesService,
    private _userService: UserService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Use this resolver to resolve initial mock-api for the application
   *
   * @param route
   * @param state
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
      this._activeService.getCatalogActive(),
      this._userService.get(),
    ]);
  }
}
